import { EvtHeader } from "components/header";
import { useParams } from "react-router-dom";
import MilestoneForm from "@/modules/work/milestones/form";
import { useJob } from "@/modules/work/jobs/context";

const CreateMilestone = () => {
  const { jobId } = useParams();
  const { type } = useJob();

  return (
    <div className="flex-1">
      <EvtHeader title="Create Milestone" />
      <div className="p-6 max-w-md">
        <MilestoneForm
          defaultJobId={jobId}
          type={type}
        />
      </div>
    </div>
  );
};

export default CreateMilestone;
